import {USER_KEYS} from "@/api/userApi";
import RefluencedLogo from "@/assets/images/refluenced.svg?react";
import Modal from "@/components/Common/Modal";
import {useLogout} from "@/hooks/useLogout";
import {client} from "@/httpClient";
import {isConfirmEmailModalOpenAtom} from "@/store/jotaiAtoms";
import useUserStore from "@/store/user";
import {useMutation} from "@tanstack/react-query";
import {useSetAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const ConfirmEmailModal: FC = () => {
  const {t} = useTranslation(["getting_started", "navigation"]);
  const user = useUserStore(state => state.user);
  const setIsOpen = useSetAtom(isConfirmEmailModalOpenAtom);
  const logout = useLogout();

  const {mutate: resendVerificationEmail, isPending: isResendingVerificationEmail} = useMutation({
    meta: {successMessage: t("email_sent")},
    mutationKey: USER_KEYS.mUserResendVerificationEmail,
    mutationFn: () =>
      client.post(USER_KEYS.mUserResendVerificationEmail[0], {
        user_id: user.id,
      }),
  });

  return (
    <Modal
      onClose={() => void 0}
      customBottomRow={<></>}
      customTitleRow={<></>}
      shouldHideCloseButton
      backgroundClassName="max-w-120 rounded-2.5xl border border-primary-light-solid">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-5">
            <RefluencedLogo className="size-10 shrink-0" />
            <h2 className="text-neutral-black m-0 text-xl font-semibold">{t("check_inbox")}</h2>
          </div>
          <span className="text-neutral-grey-dark text-sm">{t("check_inbox_explanation", {email: user.email})}</span>
        </div>
        <div className="flex items-center gap-5">
          <div className="bg-primary-light-solid h-px flex-1" />
          <span className="text-neutral-grey-dark text-sm">{t("email_not_received")}</span>
          <div className="bg-primary-light-solid h-px flex-1" />
        </div>
        <div className="flex flex-col gap-3">
          <span className="text-neutral-grey-dark text-sm">{t("check_spam_folder")}</span>
          <button
            onClick={() => resendVerificationEmail()}
            disabled={isResendingVerificationEmail}
            className="text-primary-dark-solid enabled:hover:text-primary-medium-solid disabled:text-neutral-grey-dark w-fit text-sm leading-4 font-medium transition-colors duration-150 disabled:cursor-not-allowed">
            {t("resend_email")}
          </button>
          <button
            onClick={async () => {
              await logout();
              setIsOpen(false);
            }}
            className="text-primary-dark-solid enabled:hover:text-primary-medium-solid disabled:text-neutral-grey-dark w-fit text-sm leading-4 font-medium transition-colors duration-150 disabled:cursor-not-allowed">
            {t("navigation:logout")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmEmailModal;
